import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ColeccionistasService } from '../coleccionistas.service';
import { Coleccionista } from 'app/models/coleccionitas.model';
import { ActualizarColeccionista } from '../models/actualizar-coleccionista';
import { UtilsService } from 'app/modules/utils-service';
import { ParamsColeccionistas } from '../models/params-coleccionista.model';

@Component({
    selector: 'actualizar-coleccionista',
    templateUrl: 'form-actualizar-coleccionista.component.html',
    imports: [
        CommonModule,
        FormsModule,
        MatIcon,
        MatButton,
        MatFormFieldModule,
        MatInputModule
    ],
})

export class FormActualizarColeccionistaComponent implements OnInit {
    coleccionista: ActualizarColeccionista = new ActualizarColeccionista;
    paramsColeccionista:Partial<ParamsColeccionistas>
    
    constructor(
        public dialogRef: MatDialogRef<FormActualizarColeccionistaComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Coleccionista,
        private _coleccionistasService: ColeccionistasService,
        private _utilsService: UtilsService
    ) { 
        
    }

    ngOnInit() {
        this.paramsColeccionista = {inicio:0, max:10};

        if (this.data) {
            this.coleccionista.nombre = this.data.nombre;
            this.coleccionista.correoElectronico = this.data.correoElectronico;
            this.coleccionista.telefono = this.data.telefono;
        }
     }
    
    getColeccionistas(params:any){
        this._coleccionistasService.getColeccionistas(params)
    }

    tieneCambios(): boolean {
        return (
            this.coleccionista.nombre !== this.data.nombre ||
            this.coleccionista.correoElectronico !== this.data.correoElectronico ||
            this.coleccionista.telefono !== this.data.telefono
        );
    }


    actualizarDatos(){
        this._coleccionistasService.actualizarColeccionista(this.coleccionista, this.data.coleccionistaUuid)
            .then((response)=>{
                this.dialogRef.close(true);
                this._utilsService.openSuccessSnakBar('Coleccionista actualizado correctamente.');
                this.getColeccionistas(this.paramsColeccionista)
            })
            .catch((error)=>{
                console.error('Error al actualizar coleccionista:', error);
            });
    }
}